import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import DynamicReport from './dynamic-report/DynamicReport';
import AttachmentList from "./attachments/AttachmentList";
import NoteList from "./notes/NoteList";

class ReportView extends Component {

  componentDidMount() {
    //console.log(this.props.report)
    this.props.loadReportEdit(this.props.report.guid)
  }

  render() {
    return (
      <Fragment>
        {this.props.report &&
          <DynamicReport
            report={this.props.report}
            phase={this.props.phase}
            view={this.props.report.getReportView()}
            onChangePhase={() => this.props.onChangePhase && this.props.onChangePhase(this.props.report)}
            onOpenTasks={() => this.props.onOpenTasks && this.props.onOpenTasks(this.props.report)}
          >
            { this.props.attachments && (
              <div style={{padding: '20px'}}>
                <AttachmentList
                  attachments={this.props.attachments}
                  disableEdit
                />
              </div>
            )}
            { this.props.notes && (
              <div style={{padding: '20px'}}>
                <NoteList
                  notes={this.props.notes}
                  disableEdit
                />
              </div>
            )}
          </DynamicReport>
        }
      </Fragment>
    );
  }
}
// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    notes: state.notes.list,
    attachments: state.attachments.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeViewReport: () => {
      dispatch(trainingPhasesActionCreators.closeViewReport());
    },
    loadReportEdit: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.loadReportEdit(reportGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportView);

